import styled from "styled-components"

export default styled.ul`
  text-transform: capitalize;
  display: block;
  margin: 15px 15px 0 0;
`
